module.exports = __webpack_public_path__ + "img/b6c17fa9a15b95f5f213d007c536b835.svg";